// extracted by mini-css-extract-plugin
export default {"tooltip":"rn-z","sharingV2":"sn-z","sharingIconsV2":"tn-z","links":"un-z","link":"vn-z","facebookV2":"wn-z","twitterV2":"xn-z","pinterestV2":"yn-z"};